export const toggleBoxStyle = {
  borderRadius: '16px',
  padding: '4px 10px',
  cursor: 'pointer',
};

export const toggleBoxStyleSelected = {
  color: 'white',
  backgroundColor: 'black',
};
